import { render, staticRenderFns } from "./DevedorEditar.vue?vue&type=template&id=cfc4fbdc&"
import script from "./DevedorEditar.vue?vue&type=script&lang=js&"
export * from "./DevedorEditar.vue?vue&type=script&lang=js&"
import style0 from "./DevedorEditar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports